module.exports = __webpack_public_path__ + "28fb64c06cd494571aa3293417c208a9.svg";